import React, {Component} from "react";
import config from 'react-global-configuration';
import jwt_decode from "jwt-decode";
import axios from "axios";
import { isApiResponse, isReportAccess, compareValues } from '../helpers/utils.js';
import {connect} from "react-redux";
import {BeatLoader} from "react-spinners";
import {css} from "@emotion/core";
import ReactMultiSelectCheckboxes from 'react-multiselect-checkboxes';

import LastRefresh from './LastRefresh.jsx';
const override = css `
    display: block;
    margin: 0 auto;
    border-color: red;
    text-align: center;
`;

class PortfolioPerformanceReport extends Component{
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            data: [],
            error: null,
            extra_data: {},
            expandedASEs: {},

            aseList: [],
            asoList: [],
            stateList: [],
            cityList: [],

            aseValue: [],
            asoValue: [],
            stateValue: [],
            cityValue: [],

            active_aseids: [],
            active_asoids: [],
            active_stateids: [],
            active_cityids: [],

            isChange: false,
            sortKey: null,
            sortDir: 'asc'
        }
    }

    handleSort = (key) => {
        this.setState(prevState => ({
            sortKey: key,
            sortDir: prevState.sortKey === key && prevState.sortDir === 'asc' ? 'desc' : 'asc'
        }));
    }

    getSortedGroupedData(groupedData) {
        const { sortKey, sortDir } = this.state;
        if (!sortKey) return groupedData;

        const aseKeys = Object.keys(groupedData);

        if (sortKey === 'ASE') {
            const sorted = [...aseKeys].sort((a, b) => {
                if (a < b) return sortDir === 'asc' ? -1 : 1;
                if (a > b) return sortDir === 'asc' ? 1 : -1;
                return 0;
            });
            const result = {};
            sorted.forEach(k => { result[k] = groupedData[k]; });
            return result;
        }

        const keyMap = {
            'ASO': 'ASO',
            'State': 'State',
            'City': 'City',
            'Stores Allocated': 'Stores Allocated',
            'UTID Allocated': 'UTID allocated',
            'Service Tickets (TAT)': 'Open service tickets out of  TAT',
            'NTS Stores': 'NTS stores',
            'Churned Retrieval': 'Open churned retrieval tickets',
            'NTCR Tickets': 'Open NTCR tickets'
        };
        const dataKey = keyMap[sortKey] || sortKey;

        const result = {};
        aseKeys.forEach(ase => {
            result[ase] = [...groupedData[ase]].sort((a, b) => {
                const av = a[dataKey];
                const bv = b[dataKey];
                const an = parseFloat(av);
                const bn = parseFloat(bv);
                if (!isNaN(an) && !isNaN(bn)) {
                    return sortDir === 'asc' ? an - bn : bn - an;
                }
                const as = (av || '').toString();
                const bs = (bv || '').toString();
                if (as < bs) return sortDir === 'asc' ? -1 : 1;
                if (as > bs) return sortDir === 'asc' ? 1 : -1;
                return 0;
            });
        });
        return result;
    }

    renderSortArrow(key) {
        const { sortKey, sortDir } = this.state;
        if (sortKey !== key) return <span style={{color: '#aaa', marginLeft: '4px'}}>⇅</span>;
        return <span style={{marginLeft: '4px'}}>{sortDir === 'asc' ? '▲' : '▼'}</span>;
    }

    componentWillMount() {
        this.props.currentMenu("unipaynext");
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        const tokenPermission = localStorage.userPermission;
        const decoded_permission = jwt_decode(tokenPermission);
        let AllAccessPermissions = decoded_permission.accessPermissions;
        isReportAccess(AllAccessPermissions, "portfolio_performance_report");

        this.setState({
            user_id: decoded._id,
            object_type: decoded.object_type,
        });
    }

    componentDidMount() {
        this._get_ase_list();
        this._get_aso_list();
        this._get_state_list();
        this._get_city_list();
        this.get_aso_beat_plan_report();
    }

    _get_ase_list() {
        axios.get(config.get('API_URL') + '/filters/get-ase-list', {
            headers: { Authorization: localStorage.usertoken }
        })
        .then(response => {
            if (response.data && response.data.data && Array.isArray(response.data.data)) {
                const aseOptions = response.data.data.map((item) => ({
                    value: item.ASE,
                    label: item.ASE
                }));
                this.setState({ aseList: aseOptions });
            }
        })
        .catch(err => console.error("Error loading ASE:", err));
    }

    _get_aso_list() {
        const aseArray = this.state.aseValue.map(opt => opt.value);
        axios.post(config.get('API_URL') + '/filters/get-aso-list',
            { ase_list: aseArray },
            { headers: { Authorization: localStorage.usertoken } }
        )
        .then(response => {
            if (response.data && response.data.data && Array.isArray(response.data.data)) {
                const asoOptions = response.data.data.map((item) => ({
                    value: item.ASO,
                    label: item.ASO
                }));
                this.setState({ asoList: asoOptions });
            }
        })
        .catch(err => console.error("Error loading ASO:", err));
    }

    _get_state_list() {
        const aseArray = this.state.aseValue.map(opt => opt.value);
        const asoArray = this.state.asoValue.map(opt => opt.value);
        axios.post(config.get('API_URL') + '/filters/get-state-list',
            { ase_list: aseArray, aso_list: asoArray },
            { headers: { Authorization: localStorage.usertoken } }
        )
        .then(response => {
            if (response.data && response.data.data && Array.isArray(response.data.data)) {
                const stateOptions = response.data.data.map((item) => ({
                    value: item.State,
                    label: item.State
                }));
                this.setState({ stateList: stateOptions });
            }
        })
        .catch(err => console.error("Error loading State:", err));
    }

    _get_city_list() {
        const aseArray = this.state.aseValue.map(opt => opt.value);
        const asoArray = this.state.asoValue.map(opt => opt.value);
        const stateArray = this.state.stateValue.map(opt => opt.value);
        axios.post(config.get('API_URL') + '/filters/get-city-list',
            { ase_list: aseArray, aso_list: asoArray, state_list: stateArray },
            { headers: { Authorization: localStorage.usertoken } }
        )
        .then(response => {
            if (response.data && response.data.data && Array.isArray(response.data.data)) {
                const cityOptions = response.data.data.map((item) => ({
                    value: item.City,
                    label: item.City
                }));
                this.setState({ cityList: cityOptions });
            }
        })
        .catch(err => console.error("Error loading City:", err));
    }


    changeAse = (selected) => {
        let aseArray = [];
        let aseList = [...this.state.aseList];

        if (selected && selected.length > 0) {
            // Move selected to top
            selected.forEach((item) => {
                aseArray.push(item.value);
                const index = aseList.findIndex(obj => obj.value === item.value);
                if (index > -1) {
                    const [selectedItem] = aseList.splice(index, 1);
                    aseList.unshift(selectedItem);
                }
            });
        }
        this.setState({
            aseList: aseList,
            aseValue: selected || [],
            asoValue: [],
            stateValue: [],
            cityValue: [],
            isChange: true
        }, () => {
            this._get_aso_list();
            this._get_state_list();
            this._get_city_list();
        });
    }

    changeAso = (selected) => {
        let asoArray = [];
        let asoList = [...this.state.asoList];

        if (selected && selected.length > 0) {
            // Move selected to top
            selected.forEach((item) => {
                asoArray.push(item.value);
                const index = asoList.findIndex(obj => obj.value === item.value);
                if (index > -1) {
                    const [selectedItem] = asoList.splice(index, 1);
                    asoList.unshift(selectedItem);
                }
            });
        }
        this.setState({
            asoList: asoList,
            asoValue: selected || [],
            stateValue: [],
            cityValue: [],
            isChange: true
        }, () => {
            this._get_state_list();
            this._get_city_list();
        });
    }

    changeState = (selected) => {
        let stateArray = [];
        let stateList = [...this.state.stateList];

        if (selected && selected.length > 0) {
            // Move selected to top
            selected.forEach((item) => {
                stateArray.push(item.value);
                const index = stateList.findIndex(obj => obj.value === item.value);
                if (index > -1) {
                    const [selectedItem] = stateList.splice(index, 1);
                    stateList.unshift(selectedItem);
                }
            });
        }
        this.setState({
            stateList: stateList,
            stateValue: selected || [],
            cityValue: [],
            isChange: true
        }, () => {
            this._get_city_list();
        });
    }

    changeCity = (selected) => {
        let cityArray = [];
        let cityList = [...this.state.cityList];

        if (selected && selected.length > 0) {
            // Move selected to top
            selected.forEach((item) => {
                cityArray.push(item.value);
                const index = cityList.findIndex(obj => obj.value === item.value);
                if (index > -1) {
                    const [selectedItem] = cityList.splice(index, 1);
                    cityList.unshift(selectedItem);
                }
            });
        }

        const is_enable = compareValues(cityArray, this.state.active_cityids);

        this.setState({
            cityList: cityList,
            cityValue: selected || [],
            isChange: true
        });
    }

    resetFilters = () => {
        this.setState({
            aseValue: [],
            asoValue: [],
            stateValue: [],
            cityValue: [],
            isChange: false
        }, () => {
            this._get_ase_list();
            this._get_aso_list();
            this._get_state_list();
            this._get_city_list();
            this.get_aso_beat_plan_report();
        });
    }


    get_aso_beat_plan_report() {
        this.setState({ loading: true });
        isApiResponse(false);

        const asoArray = this.state.asoValue.map(opt => opt.value);
        const aseArray = this.state.aseValue.map(opt => opt.value);
        const stateArray = this.state.stateValue.map(opt => opt.value);
        const cityArray = this.state.cityValue.map(opt => opt.value);

        let postData = {

            aso: asoArray,
            ase: aseArray,
            state: stateArray,
            city: cityArray,
            download: 0,
            report_code: "portfolio_performance_report"

        };
        console.log(postData)
        axios.post(config.get('API_URL') + "/InternalReport/portfolio-performance-report", postData, {
            headers: { Authorization: localStorage.usertoken }
        })
        .then(response => {
            isApiResponse(true);
            if (response.data && response.data.data) {
                const grouped = {};
                response.data.data.forEach(row => {
                    const ase = row.ASE || 'Unknown';
                    if (!grouped[ase]) {
                        grouped[ase] = true;
                    }
                });

                this.setState({
                    data: response.data.data,
                    extra_data: response.data.extra_data || {},
                    expandedASEs: grouped,
                    loading: false,
                    error: null,
                    active_aseids: aseArray,
                    active_asoids: asoArray,
                    active_stateids: stateArray,
                    active_cityids: cityArray,
                    isChange: false
                });
            }
        })
        .catch(error => {
            isApiResponse(true);
            this.setState({
                loading: false,
                error: "Failed to load data"
            });
            console.error("API Error:", error);
        });
    }

    shouldComponentUpdate(nextProps, nextState) {

        return true;
    }

    getAdherenceColor(adherenceStr) {
        if (!adherenceStr) return 'transparent';
        if (adherenceStr === 'OFF' || adherenceStr === 'ABS') return '#f0f0f0';
        let value = parseInt(adherenceStr);
        if (isNaN(value)) return 'transparent';
        if (value < 70) return '#ffcccc';
        if (value < 85) return '#ffffcc';
        return '#ccffcc';
    }

    getTextColor(adherenceStr) {
        if (adherenceStr === 'OFF' || adherenceStr === 'ABS') return '#333';
        let value = parseInt(adherenceStr);
        if (isNaN(value)) return '#333';
        if (value < 70) return '#d32f2f';
        if (value < 85) return '#f57f17';
        return '#388e3c';
    }

    cleanPercentageValue(val) {
        if (!val) return '-';
        if (val === 'OFF' || val === 'ABS') return val;
        return val.toString().replace('%%', '%');
    }

    groupDataByASE() {
        const { data } = this.state;
        const grouped = {};
        data.forEach(row => {
            const ase = row.ASE || 'Unknown';
            if (!grouped[ase]) {
                grouped[ase] = [];
            }
            grouped[ase].push(row);
        });
        return grouped;
    }

    getLowestForASE(aseRows) {
        const allColumns = Object.keys(aseRows[0]);
        const adherenceCols = allColumns.filter(col => col.includes('Adherence'));
        const lowestValues = {};

        adherenceCols.forEach(col => {
            let lowest = null;
            aseRows.forEach(row => {
                const val = row[col];
                if (val && val !== 'OFF' && val !== 'ABS') {
                    const numVal = parseInt(val);
                    if (!isNaN(numVal)) {
                        if (lowest === null || numVal < lowest) {
                            lowest = numVal;
                        }
                    }
                }
            });
            lowestValues[col] = lowest;
        });
        return lowestValues;
    }

    toggleASEExpand = (aseName) => {
        this.setState(prevState => ({
            expandedASEs: {
                ...prevState.expandedASEs,
                [aseName]: !prevState.expandedASEs[aseName]
            }
        }));
    }

    render() {
        const { loading, error } = this.state;
        const rawGroupedData = this.groupDataByASE();
        const groupedData = this.getSortedGroupedData(rawGroupedData);

        let headerColumns = [];
        const firstASEKey = Object.keys(groupedData)[0];
        if (firstASEKey && groupedData[firstASEKey].length > 0) {
            const allColumns = Object.keys(groupedData[firstASEKey][0]);
            headerColumns = allColumns.filter(col => col.includes('Adherence'));
        }

        if (loading) {
            return (
                <div className="content-invoice">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="card">
                                    <div className="header">
                                        <h4 className="title">Portfolio Performance Report</h4>
                                    </div>
                                    <div className="content">
                                        <BeatLoader css={override} size={15} color={"#51bcda"} loading={loading} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            );
        }

        if (error) {
            return (
                <div className="content-invoice">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="card">
                                    <div className="header">
                                        <h4 className="title">Portfolio Performance Report</h4>
                                    </div>
                                    <div className="content">
                                        <div className="alert alert-danger">{error}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            );
        }

        return (
            <div className="content-invoice">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="card">
                                <div className="col-md-9 no-padd">
                                    <div className="header">
                                        <h4 className="title">Portfolio Performance Report</h4>
                                        <LastRefresh />
                                    </div>
                                </div>
                                <div className="clearfix"></div>

                                {/* FILTERS */}
                                <div className="content" style={{backgroundColor: '#f5f5f5', padding: '15px', marginBottom: '15px'}}>
                                    <div className="row">
                                        {/* ASE */}
                                        <div className="col-md-2 filter-bottom5 padd-5">
{/*                                             <label style={{fontWeight: 'bold'}}> */}
{/*                                                 ASE ({this.state.aseValue.length}) */}
{/*                                             </label> */}
                                            <ReactMultiSelectCheckboxes
                                                name="ase"
                                                isMulti
                                                value={this.state.aseValue}
                                                options={this.state.aseList}
                                                onChange={this.changeAse}
                                                placeholderButtonLabel="Select [ASE]"
                                                className="report-listbox"
                                                isClearable={true}
                                            />
                                            <div className="clearfix"></div>
                                        </div>

                                        {/* ASO */}
                                        <div className="col-md-2 filter-bottom5 padd-5">
{/*                                             <label style={{fontWeight: 'bold'}}> */}
{/*                                                 ASO ({this.state.asoValue.length}) */}
{/*                                             </label> */}
                                            <ReactMultiSelectCheckboxes
                                                name="aso"
                                                isMulti
                                                value={this.state.asoValue}
                                                options={this.state.asoList}
                                                onChange={this.changeAso}
                                                placeholderButtonLabel="Select [ASO]"
                                                className="report-listbox"
                                                isClearable={true}
                                            />
                                            <div className="clearfix"></div>
                                        </div>

                                        {/* STATE */}
                                        <div className="col-md-2 filter-bottom5 padd-5">
{/*                                             <label style={{fontWeight: 'bold'}}> */}
{/*                                                 State ({this.state.stateValue.length}) */}
{/*                                             </label> */}
                                            <ReactMultiSelectCheckboxes
                                                name="state"
                                                isMulti
                                                value={this.state.stateValue}
                                                options={this.state.stateList}
                                                onChange={this.changeState}
                                                placeholderButtonLabel="Select [State]"
                                                className="report-listbox"
                                                isClearable={true}
                                            />
                                            <div className="clearfix"></div>
                                        </div>

                                        {/* CITY */}
                                        <div className="col-md-2 filter-bottom5 padd-5">
{/*                                             <label style={{fontWeight: 'bold'}}> */}
{/*                                                 City ({this.state.cityValue.length}) */}
{/*                                             </label> */}
                                            <ReactMultiSelectCheckboxes
                                                name="city"
                                                isMulti
                                                value={this.state.cityValue}
                                                options={this.state.cityList}
                                                onChange={this.changeCity}
                                                placeholderButtonLabel="Select [City]"
                                                className="report-listbox"
                                                isClearable={true}
                                            />
                                            <div className="clearfix"></div>
                                        </div>

                                        {/* BUTTONS */}
                                        <div className="col-md-4 padd-5" style={{paddingTop: '7px'}}>
                                            <button
                                                type="button"
                                                className="primary apply-filter"
                                                role="button"
//                                                 disabled={!this.state.isChange}
                                                onClick={this.get_aso_beat_plan_report.bind(this)}
                                            >
                                             Apply
                                            </button>
                                            &nbsp;
                                            <button
                                                type="button"
                                                className="primary reset-filter"
                                                role="button"
                                                onClick={this.resetFilters}
                                            >
                                            Reset
                                            </button>
                                        </div>
                                    </div>
                                </div>

                                <div className="clearfix"></div>

                                {/* TABLE */}
                                <div className="content">
                                    <div className="content-tdetails-table table-full-width table-responsive marginTop0">
                                        <table className="table table-striped table-hover portfolio-table">
                                            <thead>
                                                <tr style={{backgroundColor: '#5e35b1', color: 'white'}}>
                                                    {['ASE', 'ASO', 'State', 'City', 'Stores Allocated', 'UTID Allocated', 'Service Tickets (TAT)', 'NTS Stores', 'Churned Retrieval', 'NTCR Tickets'].map(col => (
                                                        <th key={col} style={{cursor: 'pointer', userSelect: 'none', maxWidth: col === 'NTS Stores' || col === 'NTCR Tickets' ? '60px' : undefined}}
                                                            onClick={() => this.handleSort(col)}>
                                                            {col}{this.renderSortArrow(col)}
                                                        </th>
                                                    ))}
                                                    {headerColumns.map((col) => (
                                                        <th key={col} style={{maxWidth: '80px', cursor: 'pointer', userSelect: 'none'}}
                                                            onClick={() => this.handleSort(col)}>
                                                            {col.replace(' %%', '%')}{this.renderSortArrow(col)}
                                                        </th>
                                                    ))}
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {Object.keys(groupedData).map((ase, aseIdx) => {
                                                    const aseRecords = groupedData[ase];
                                                    const adherenceCols = aseRecords.length > 0 ?
                                                        Object.keys(aseRecords[0]).filter(col => col.includes('Adherence')) : [];
                                                    const lowestForASE = this.getLowestForASE(aseRecords);
                                                    const isExpanded = this.state.expandedASEs[ase] === true;

                                                    return (
                                                        <React.Fragment key={aseIdx}>
                                                            <tr style={{backgroundColor: '#3a4a5c', color: 'white', fontWeight: 'bold', cursor: 'pointer'}}
                                                                onClick={() => this.toggleASEExpand(ase)}>
                                                                <td colSpan={10 + headerColumns.length} style={{padding: '10px', color: 'white'}}>
                                                                    <span style={{marginRight: '10px', display: 'inline-block', minWidth: '15px', color: 'white'}}>
                                                                        {isExpanded ? '▼' : '▶'}
                                                                    </span>
                                                                    {ase} ({aseRecords.length} ASOs)
                                                                </td>
                                                            </tr>

                                                            {isExpanded && aseRecords.map((row, rowIdx) => (
                                                                <tr key={rowIdx} style={{backgroundColor: rowIdx % 2 === 0 ? '#f9f9f9' : '#fff'}}>
                                                                    <td>{row.ASE || '-'}</td>
                                                                    <td><strong>{row.ASO}</strong></td>
                                                                    <td>{row.State || '-'}</td>
                                                                    <td>{row.City || '-'}</td>
                                                                    <td>{row['Stores Allocated'] || '-'}</td>
                                                                    <td>{row['UTID allocated'] || '-'}</td>
                                                                    <td>{row['Open service tickets out of  TAT'] || '-'}</td>
                                                                    <td>{row['NTS stores'] || '-'}</td>
                                                                    <td>{row['Open churned retrieval tickets'] || '-'}</td>
                                                                    <td>{row['Open NTCR tickets'] || '-'}</td>

                                                                    {adherenceCols.map((col, colIdx) => (
                                                                        <td key={colIdx} style={{
                                                                            backgroundColor: this.getAdherenceColor(row[col]),
                                                                            color: this.getTextColor(row[col]),
                                                                            fontWeight: 'bold',
                                                                            textAlign: 'center',
                                                                            padding: '10px'
                                                                        }}>
                                                                            {this.cleanPercentageValue(row[col])}
                                                                        </td>
                                                                    ))}
                                                                </tr>
                                                            ))}

                                                            {isExpanded && (
                                                                <tr style={{backgroundColor: '#3a4a5c', color: 'white', fontWeight: 'bold'}}>
                                                                    <td colSpan={10} style={{textAlign: 'right', padding: '10px', color: 'white'}}>
                                                                        {ase} (Lowest)
                                                                    </td>
                                                                    {adherenceCols.map((col, colIdx) => {
                                                                        const lowestVal = lowestForASE[col] !== null ? lowestForASE[col] + '%' : '-';
                                                                        return (
                                                                            <td key={colIdx} style={{
                                                                                backgroundColor: this.getAdherenceColor(lowestVal),
                                                                                color: this.getTextColor(lowestVal),
                                                                                fontWeight: 'bold',
                                                                                textAlign: 'center',
                                                                                padding: '10px'
                                                                            }}>
                                                                                {lowestForASE[col] !== null ? lowestForASE[col] + '%' : '-'}
                                                                            </td>
                                                                        );
                                                                    })}
                                                                </tr>
                                                            )}
                                                        </React.Fragment>
                                                    );
                                                })}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>

                                <div className="footer">
                                    <div className="stats">
                                        <i className="fa fa-info-circle"></i>
                                        Total Records: {this.state.extra_data.total_records || 0}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        currentMenu: (name) => {dispatch({type:'change_menu', payload: name})}
    }
}

export default connect(null, mapDispatchToProps)(PortfolioPerformanceReport);